import log from './log';
import { ensureTracking } from './ensureTracking';
import { LogLevel } from '../enums/Enum';
import GlobalVariables from '../GlobalVariables';
import internalTrack from './internalTrack';
import fire from './fire';

const trackTime = (category, action, value) => {
    value = value || new Date().getTime() - GlobalVariables.TrackerNow;

    internalTrack('timing', category, action, value);

    if (!window.ApexChatAnalyticsID) {
        return;
    }
    ensureTracking();

    log(`Tracking time, ${category} - ${action}: ${value}`, LogLevel.Debug);
    const data = {
        hitType: 'timing',
        timingCategory: category,
        timingVar: action,
        timingLabel: ApexChatCompanyKey,
        timingValue: value
    };
    __apexGA('apex.send', data);

    fire(`${category}:${action}`, {
        key: ApexChatCompanyKey,
        dt: value
    });
};
export default trackTime;
